module.exports = {
      id: "ic-candle-grayscale-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite-ad374a.smartcharts.svg#ic-candle-grayscale-usage",
      toString: function () {
        return this.url;
      }
    }